module.exports = __webpack_public_path__ + "static/people-logo-35959d75e42d0379eb45b918ac0e5094.png";